
import Vue from "vue";
import { EventBus } from "../main";

const formatCatalogCount = (value: number) =>
  new Intl.NumberFormat("es-CL").format(value);

const normalizeCatalogCount = (value: unknown) => {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) && parsedValue >= 0 ? parsedValue : 0;
};

export default Vue.extend({
  name: "NavBar",
  data() {
    return {
      totalCatalogPymes: 0,
      hasCatalogMetrics: false,
    };
  },
  created() {
    EventBus.$on("catalogMetricsUpdated", this.handleCatalogMetricsUpdated);
  },
  beforeDestroy() {
    EventBus.$off("catalogMetricsUpdated", this.handleCatalogMetricsUpdated);
  },
  computed: {
    formattedTotalCatalogPymes(): string {
      if (!this.hasCatalogMetrics) {
        return "...";
      }

      return formatCatalogCount(this.totalCatalogPymes);
    },
  },
  methods: {
    navigate(pathname: string) {
      if (typeof window === "undefined") {
        return;
      }

      const url = new URL(window.location.origin);
      url.pathname = pathname;
      window.location.assign(url.toString());
    },
    navigateToHome() {
      this.navigate("/");
    },
    handleCatalogMetricsUpdated(payload: { totalCount?: number }) {
      this.totalCatalogPymes = normalizeCatalogCount(payload?.totalCount);
      this.hasCatalogMetrics = true;
    },
  },
});
